export default __webpack_public_path__ + "static/media/Caution.9289869a.svg";